import "./style.scss";

import React, {FC, useState} from "react";
import {Pricing} from "shared/config/pricings";
import MoneyDisplay from "components/MoneyDisplay";
import Modal from "shared/ui/Modal";
import PriceCardDetail from "components/PriceCardDetail";
import {Link} from "react-router-dom";

type PriceCardProps = {
    title: string;
    logo: string;
    price?: string;
    subtitle?: string;
    children: React.ReactNode;
    monthly?: boolean;
    plan?: Pricing | null
    isMonthActive?: boolean,
    setIsMonthActive?: (isMonthActive: boolean) => void;
    showEnSavoirePlus?: boolean;
};
const PriceCardV2: FC<PriceCardProps> = (
    { title, logo, price, subtitle,
        children, monthly, plan,
        isMonthActive, setIsMonthActive,
        showEnSavoirePlus = true
    }) => {

    const [showModal, setShowModal] = useState<boolean>(false);

    const saveMoneyValue = plan?.priceYear ? (plan?.price * 12 - plan?.priceYear!).toFixed(2) : '0'

    return (
        <>
            <div className="PriceCardV2">
                <div className="PriceCardV2__top">
                    <div className="PriceCardV2__top__header">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex flex-column">
                                <h3>{title}</h3>
                                <div className="">
                                    {price && (
                                        <div>
                                            <h3 className={monthly ? "mb-0" : ""}>{price}</h3>
                                            {monthly && <p>/mois</p>}
                                        </div>
                                    )}
                                    {plan && (
                                        <MoneyDisplay plan={plan} isMonth={isMonthActive} />
                                    )}
                                </div>
                            </div>
                            <img
                                src={logo}
                                alt={title}
                            />
                        </div>
                        <div className="d-flex flex-column gap-1">
                            <span className="text-dark text-uppercase font-M">{plan?.text}</span>
                            <span className="font-S">
                                {plan?.description}
                            </span>
                        </div>
                    </div>

                    <div className="PriceCardV2__top__body mt-10">
                        {subtitle}
                        <PriceCardDetail
                            plan={plan} features={plan?.features}
                            isMonth={isMonthActive}
                            isWithinModal={false}
                        />
                    </div>

                    <br />
                    {(plan?.features || plan?.featuresRange) && showEnSavoirePlus && (
                        <span className="savoir-plus">
                             <Link to={"#"} className="link" onClick={() => {
                                 setShowModal(true);
                             }}>
                                <u>en savoir plus</u>
                            </Link>
                        </span>
                    )}
                </div>
                <div className="PriceCardV2__bottom">
                    {children}
                </div>
            </div>
            {showModal &&
                <Modal
                    onClose={() => setShowModal(false)} isOpen={showModal} title={plan?.head} infoModal={true}
                    type={"info"}>
                    <PriceCardDetail key={plan?.title} plan={plan} features={plan?.features} isMonth={isMonthActive} />
                </Modal>
            }
        </>
    );
};

export default PriceCardV2;
